import { render, staticRenderFns } from "./ReceiveMerchandise.vue?vue&type=template&id=e977238a"
import script from "./ReceiveMerchandise.vue?vue&type=script&lang=js"
export * from "./ReceiveMerchandise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports